import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './ResponsiveBanner.module.css';

const ResponsiveBanner = () => {
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Simulate API loading
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);

        // Check screen size
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize(); // Initialize on load
        window.addEventListener('resize', handleResize);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <section className={styles.bannerSection}>
            {loading ? (
                <Skeleton height={384} />
            ) : (
                <img
                    src={
                        isMobile
                            ? 'https://stoaparis.com/cdn/shop/files/Bestseller_page_banner_mobile_c0c4793d-8a6b-4c25-a657-163096a18194.jpg'
                            : 'https://stoaparis.com/cdn/shop/files/Bestseller_page_banner_b5b89962-b5f0-4f84-bcba-269cf7acc13d.jpg'
                    }
                    alt="Banner"
                    className={styles.bannerImage}
                />
            )}
            {!loading && (
                <h1 className={styles.bannerText}>
                    
                </h1>
            )}
        </section>
    );
};

export default ResponsiveBanner;
